import { render, staticRenderFns } from "./LeaderBoardForm.vue?vue&type=template&id=35087a48&"
import script from "./LeaderBoardForm.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35087a48')) {
      api.createRecord('35087a48', component.options)
    } else {
      api.reload('35087a48', component.options)
    }
    module.hot.accept("./LeaderBoardForm.vue?vue&type=template&id=35087a48&", function () {
      api.rerender('35087a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/LeaderBoard/LeaderBoardForm.vue"
export default component.exports